// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"uncomfortable-2"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M16 8.5L14 9.62501L14 10L16 11.5M8 8.5L10 9.62501L10 10L8.00001 11.5M7.5 16.5C7.5 15.3954 8.39542 14.5 9.5 14.5C10.0332 14.5 10.5177 14.7087 10.8763 15.0488C11.1352 15.2945 11.4523 15.5 11.8092 15.5H12.1908C12.5477 15.5 12.8648 15.2945 13.1237 15.0488C13.4823 14.7087 13.9668 14.5 14.5 14.5C15.6046 14.5 16.5 15.3954 16.5 16.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Uncomfortable2Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'uncomfortable-2',
    ref,
    icon: element,
  },
));

Uncomfortable2Icon.displayName = 'Uncomfortable2Icon';

export default Uncomfortable2Icon;
